import React, { useState, useEffect, Fragment } from 'react';
import { Box, useToast, Menu, MenuButton, MenuList, MenuItem, Icon, Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, CloseButton, Tooltip, Avatar, AvatarBadge, useDisclosure, FormControl, FormLabel, Stack, Input, InputGroup, InputRightElement, MenuDivider, Portal } from '@chakra-ui/react';
import { BrowserRouter as Router, Link, } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdAddBox, MdLockReset, MdOutlineDashboard, MdOutlineDataset, MdOutlineHome, MdOutlinePerson, MdOutlineReceipt, MdOutlineTableChart, MdStopCircle, MdVisibility, MdVisibilityOff } from 'react-icons/md'
import { MdOutlineAnalytics, } from "react-icons/md";
import { MdFileOpen } from "react-icons/md";
import { BsFillInfoCircleFill, } from "react-icons/bs";
import { SearchIcon } from "@chakra-ui/icons";
import { SiJupyter } from "react-icons/si";
import { CgSearchLoading } from "react-icons/cg";
import { HiMiniAdjustmentsHorizontal } from "react-icons/hi2"
import { GiZeppelin, GiGearHammer } from "react-icons/gi";
import { PiSupersetOf } from "react-icons/pi";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { RiSurveyLine } from "react-icons/ri";
import { GrUserExpert } from "react-icons/gr";
import { MdGroups } from "react-icons/md";
import { ImExit } from "react-icons/im";
import { FaFileContract } from "react-icons/fa";
import { react_api } from '../../config';
import { HTTP_STATUS_CODES } from '../../GrinsCostant';
import { useSession } from '../../SessionContext';
import { useNavigate } from 'react-router-dom';
import { getByRole, initMenuStructureHttpService } from '../../services/http/menuStructureHttpService';
import logout from '../../services/authService';
import createAxiosInstance from '../../interceptors/useAxiosInterceptors';
import UploadDatasetModal from './UploadDatasetModal';
import SpinnerXL from '../SpinnerXL';
import { addNewTab, pulisciTab } from '../IframeTabsManager';
import { isLocalhost, removePort } from '../../services/utils';

const iconMap = {
    MdOutlineHome, MdOutlineTableChart, MdOutlineDataset, MdStopCircle,
    MdOutlineReceipt, HiMiniAdjustmentsHorizontal, MdOutlineDashboard, MdFileOpen,
    MdOutlineMiscellaneousServices, CgSearchLoading, SearchIcon, MdOutlineAnalytics,
    GiGearHammer, SiJupyter, GiZeppelin, PiSupersetOf, MdAddBox, BsFillInfoCircleFill,
    RiSurveyLine, MdGroups, GrUserExpert, FaFileContract, MdOutlinePerson, MdLockReset, ImExit
};

const NavbarDinamic = () => {
    // Modal states
    const { t } = useTranslation();
    const toast = useToast();
    const navigate = useNavigate();
    const axiosInstance = createAxiosInstance(async (axiosInstance) => {
        logout(t, clearSessionData, navigate, toast, axiosInstance)
    });

    const { updateSessionData, clearSessionData } = useSession();
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [newPassword1, setNewPassword1] = useState();
    const [newPassword2, setNewPassword2] = useState();
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [responseChangePassword, setResponseChangePassword] = useState({});
    const [dataMenu, setDataMenu] = useState([]);
    const { isOpen: isUploadOpen, onOpen: openUpload, onClose: closeUpload } = useDisclosure();
    const { isOpen: isChangePasswordModalOpen, onOpen: onChangePasswordModalOpen, onClose: onChangePasswordModalClose } = useDisclosure();
    const { isOpen: isLogoutChangePasswordModalOpen, onOpen: onChangeLogoutPasswordModalOpen, onClose: onChangeLogoutPasswordModalClose } = useDisclosure();
    const { isOpen: isLogoutModalOpen, onOpen: onLogoutModalOpen, onClose: onLogoutModalClose } = useDisclosure();
    const [hasError, setHasError] = useState(false);

    initMenuStructureHttpService(t, toast, axiosInstance);

    // useEffect(() => {
    //     const role = sessionStorage.getItem("role");
    //     getByRole(role)
    //     .then((res) => {
    //         // response shape: { status, data: { menu: [...] }}
    //         if (res.data && Array.isArray(res.data.menu)) {
    //         setDataMenu(res.data.menu);
    //         }
    //     })
    //     .catch((e) => console.error(e));
    // }, []);

    // if (!dataMenu.length) return null; // or a loading indicator

    const fetchMenu = () => {
        // setSpinnerLoading(true);
        setHasError(false);
        const role = sessionStorage.getItem("role");
        getByRole(role)
            .then((res) => {
                if (res == null) {
                    setHasError(true);
                    setSpinnerLoading(false);
                     pulisciTab()
                     navigate("/sessionInvalid")
                     logout(t, clearSessionData, navigate, toast, axiosInstance)

                     return true

                }else{
                    setDataMenu(res?.data?.menu || []);
                    setSpinnerLoading(false);
                }
            })
        .catch((e) => {
            console.error("Errore caricamento menu:", e.message);
            setHasError(true);
              setSpinnerLoading(false);
              return true
          
        });

        return false

        
    };

    useEffect(() => {
        fetchMenu();
    }, []);

    const generateAvatar = (username) => {
        const array = username.split(" ");
        const name = array[0]
        const surname = array[1] || ''
        const initials = `${name.charAt(0)} + ${surname.charAt(0)}`;

        return (
            <Avatar name={initials} size="md" bg={"#006778"} color={"yellowgreen"} paddingBottom={"2%"} paddingTop={"2%"} ><AvatarBadge bgColor={"green"} borderWidth={1} boxSize={"0.8em"} /></Avatar>
        );
    };

    const handlers = {
        handlerUploadModal: openUpload, 
        handlerChangePasswordModal: () => openChangePwd(),
        handlerLogoutModal: () => openLogout()
    };

    const openChangePwd=()=>{
        onChangePasswordModalOpen();
    }

    const openLogout=()=>{
        onLogoutModalOpen();
    }

    const changePasswordADP = async () => {
        try {
            setSpinnerLoading(true);
            if (newPassword1.length < 8 || newPassword1.length > 15) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordError'),
                    description: t('toastMsg.navbar.passwordErrorLenght'),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (/[@'"]/.test(newPassword1)) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordError'),
                    description: t('toastMsg.navbar.passwordErrorSpecialCharacter'),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (!/\d/.test(newPassword1)) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordError'),
                    description: t('toastMsg.navbar.passwordErrorNotContainOneNumber'),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (!/[A-Z]/.test(newPassword1)) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordError'),
                    description: t('toastMsg.navbar.passwordErrorNotContainOneCapitalLetter'),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (!/[!#$%&()*+,\-./:;<=>?[\]^_`{|}~]/.test(newPassword1)) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordError'),
                    description: t('toastMsg.navbar.passwordErrorNotContainOneSpecialCharacter'),
                    position: "top",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
                return;
            }
            if (newPassword1 == newPassword2) {

                const urlFetch = `${react_api}/changePasswordADP`;
                const richiesta = {
                    BearerToken: sessionStorage.getItem('token'),
                    newPass: newPassword1
                }
                const options = {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }
                const response = await axiosInstance.post(urlFetch, richiesta, options);

                if (response.data.status === HTTP_STATUS_CODES.OK) {
                    setSpinnerLoading(false);
                    setResponseChangePassword(response.data)
                    onChangePasswordModalClose()
                    onChangeLogoutPasswordModalOpen()
                    toast({
                        title: t(`messageBE.${response.data.message}`),
                        position: "top",
                        status: 'success',
                        duration: 6000,
                        isClosable: true
                    });
                }
            } else {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.navbar.passwordMismatch'),
                    position: "top",
                    status: 'warning',
                    duration: 6000,
                    isClosable: true
                });
            }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t('toastMsg.navbar.passwordChangeError'),
                description: String(error.message),
                position: "top",
                status: 'warning',
                duration: 6000,
                isClosable: true
            });
        }
    }

    const handleChangePassword1 = (ev) => {
        setNewPassword1(ev.target.value.trim())
    }

    const handleChangePassword2 = (ev) => {
        setNewPassword2(ev.target.value.trim())
    }

    const handlePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };

    const handlePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };

    const logOut = async () => {
        let toastId = 1

        if (toast.isActive(toastId)) {
            toast.close(toastId);
        }
        try {
            setSpinnerLoading(true);
            const richiesta = {
                BearerToken: sessionStorage.getItem("token"),
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(richiesta),
            }

            const urlFetch = `${react_api}/logoutADP`;
            const response = await fetch(urlFetch, options);
            const result = await response.json();
            if (result.status !== HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                toast({
                    title: t('toastMsg.error'),
                    description: t(`messageBE.${result.message}`),
                    position: "top",
                    status: 'error',
                    duration: 4000,
                    isClosable: true
                });
            }
            if (result.status === HTTP_STATUS_CODES.OK) {
                setSpinnerLoading(false);
                if (!toast.isActive(toastId)) {
                    toast({
                        id: toastId,
                        title: t('toastMsg.navbar.logoutSuccess'),
                        description: String(result.message),
                        position: "top",
                        status: 'info',
                        duration: 1700,
                        isClosable: true, onCloseComplete: () => {
                            clearSessionData();
                            navigate('/home');
                            window.location.reload();
                        }
                    });
                }
            }
        } catch (error) {
            setSpinnerLoading(false);
            toast({
                title: t('toastMsg.callError'),
                description: String(error),
                position: "top",
                status: 'warning',
                duration: 4000,
                isClosable: true
            });
        }
    };

    const dividerSubMenu = ["myResults", "dashboard", "lcaCatalog", "uploadDataset", "expertCatalog", "consensusSurveys", "info", "logout"];

    if (hasError) {
        return (
            <Box textAlign="center" mt={4}>
                <Text color="red.500" mb={2}>
                    {t('navbar.errorLoadingMenu')}
                </Text>
                <Button maxW={"90%"} colorScheme="teal" onClick={fetchMenu}>
                    {t('navbar.tryAgain')}
                </Button>
                <Button maxW={"90%"} mt={2} colorScheme='red' onClick={() => logOut()}>
                    Logout
                </Button>
            </Box>
        );
    }
    
    return (
        <>
            {spinnerLoading && (
            <SpinnerXL />
            )}
            <Menu minH="100%" minW="100%">
                {dataMenu.map(item => (
                    <Fragment>
                        {item.key === "profile" ?
                            <Box mt="auto" alignSelf={"bottom"} h="15%">
                                <MenuItem _focus={{ bg: "#006778" }} padding={0}>
                                    <Menu placement="right-start">
                                        <Tooltip label={t(`${item.toolTip}`)} placement="right" trigger="hover">
                                            <MenuButton color={"yellowgreen"} w="100%" h="100%" padding={"2%"} transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{  bg: "#006778" }} >
                                                {sessionStorage.displayName === "anonymous" || !sessionStorage.displayName ? (<Icon as={MdOutlinePerson} w={"30%"} h={"30%"} />) : (generateAvatar(sessionStorage.displayName))}
                                                <Text fontSize={"sm"}>{t(`${item.label}`)}</Text>
                                            </MenuButton>
                                        </Tooltip>
                                        <Portal>
                                            <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} ml={-2}>
                                                    {item.children.map((sub, idx) => (
                                                    sub.action
                                                        ? 
                                                        <>
                                                            {dividerSubMenu.includes(sub.key) && idx > 0 && (
                                                                <MenuDivider />
                                                            )}
                                                            <Tooltip key={sub.key} label={t(`${sub.toolTip}`)} placement="right" trigger="hover">
                                                                <MenuItem key={sub.key} onClick={handlers[sub.action]} _hover={{ bg: "gray.300" }}>
                                                                    <Icon as={iconMap[sub.icon]} mr={2} /> 
                                                                    <Text fontSize={"sm"}>
                                                                        {t(`${sub.label}`)}
                                                                    </Text>
                                                                </MenuItem>
                                                            </Tooltip>
                                                        </>
                                                        : 
                                                        <>
                                                            {dividerSubMenu.includes(sub.key) && idx > 0 && (
                                                                <MenuDivider />
                                                            )}
                                                            <Link key={sub.key}  onClick={()=> {
                                if(fetchMenu())
                                    return



                              
                                                                
                                                         addNewTab( { name: t(`${sub.label}`), url: isLocalhost()?  `http://localhost:3000${sub.path}?hideHeader=true&hideNavbar=true`:  `${removePort(react_api)}${sub.path}?hideHeader=true&hideNavbar=true`, description : "" })

                                                            }}>
                                                                <Tooltip label={t(`${sub.toolTip}`)} placement="right" trigger="hover">
                                                                    <MenuItem _hover={{ bg: "gray.300" }}>
                                                                        <Icon as={iconMap[sub.icon]}  mr={2} /> 
                                                                        <Text fontSize={"sm"}>
                                                                            {t(`${sub.label}`)}
                                                                        </Text>
                                                                    </MenuItem>
                                                                </Tooltip>
                                                            </Link>
                                                        </>
                                                    ))}
                                            </MenuList>
                                        </Portal>
                                    </Menu>
                                </MenuItem>
                            </Box>
                        : 
                        item.children.length > 0
                        ? 
                            <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
                                <Menu placement="right-start">
                                    <Tooltip label={t(`${item.toolTip}`)} placement="right" trigger="hover">
                                        <MenuButton color={ "yellowgreen"} w="100%" h="100%" padding={"2%"} transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: "#006778" }} _focus={{ bg: "#006778" }}>
                                            <Icon as={iconMap[item.icon]} w={"30%"} h={"30%"} />
                                            <Text fontSize={"sm"}>
                                                {t(`${item.label}`)}
                                            </Text>
                                        </MenuButton>
                                    </Tooltip>
                                    <Portal>
                                        <MenuList border="solid" borderColor="rgba(11,78,90,255)" borderWidth="1"  ml={-2} >
                                            {item.children.map((sub, idx) => (
                                            sub.action
                                                ? 
                                                <>
                                                    {dividerSubMenu.includes(sub.key) && idx > 0 &&  (
                                                        <MenuDivider />
                                                    )}
                                                    <Tooltip key={sub.key} label={t(`${sub.toolTip}`)} placement="right" trigger="hover">
                                                        <MenuItem key={sub.key} onClick={handlers[sub.action]} _hover={{ bg: "gray.300" }}>
                                                            <Icon as={iconMap[sub.icon]} mr={2} /> 
                                                            <Text fontSize={"sm"}>
                                                                {t(`${sub.label}`)}
                                                            </Text>
                                                        </MenuItem>
                                                    </Tooltip>
                                                </>
                                                : 
                                                <>
                                                    {dividerSubMenu.includes(sub.key) && idx > 0 &&  (
                                                        <MenuDivider />
                                                    )}
                                                     <Link key={sub.key} onClick={()=> {

                                                  if(fetchMenu())
                                                    return

                                if(hasError) {
pulisciTab()
                                     logout(t, clearSessionData, navigate, toast, axiosInstance)
                                     return
                                }
                                                               addNewTab( { name: t(`${sub.label}`), url: isLocalhost()?  `http://localhost:3000${sub.path}?hideHeader=true&hideNavbar=true`:  `${removePort(react_api)}${sub.path}?hideHeader=true&hideNavbar=true`, description : "" })
                                                     }}>
                                                        <Tooltip label={t(`${sub.toolTip}`)} placement="right" trigger="hover">
                                                            <MenuItem _hover={{ bg: "gray.300" }}>
                                                                <Icon as={iconMap[sub.icon]}  mr={2} /> 
                                                                <Text fontSize={"sm"}>
                                                                    {t(`${sub.label}`)}
                                                                </Text>
                                                            </MenuItem>
                                                        </Tooltip>
                                                    </Link>
                                                </>
                                            ))}
                                        </MenuList>
                                    </Portal>
                                </Menu>
                            </MenuItem>
                        : item.action
                            ?   <Tooltip key={item.key} label={t(`${item.toolTip}`)} placement="right" trigger="hover">
                                    <MenuItem onClick={handlers[item.action]} _hover={{ bg: "gray.300" }}>
                                        <Icon as={iconMap[item.icon]}  w={"30%"} h={"30%"} /> 
                                        <Text fontSize={"sm"}>
                                            {t(`${item.label}`)}
                                        </Text>
                                    </MenuItem>
                                </Tooltip> 
                            :   <Link  onClick={()=> {

                                if(fetchMenu())
                                    return

                                if(hasError) {
                                    pulisciTab()
                                     logout(t, clearSessionData, navigate, toast, axiosInstance)
                                     return 
                                }

                                addNewTab( { name: t(`${item.label}`), url: isLocalhost()?  `http://localhost:3000${item.path}?hideHeader=true&hideNavbar=true`:  `${removePort(react_api)}${item.path}?hideHeader=true&hideNavbar=true` , description : "" })

                                
                                }}>
                                    <Tooltip label={t(`${item.toolTip}`)} placement="right" trigger="hover">
                                        <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
                                            <MenuButton color={"yellowgreen"} w="100%" h="100%" padding={"2%"} transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }} >
                                                <Icon as={iconMap[item.icon]}  w={"30%"} h={"30%"} /> 
                                                <Text fontSize={"sm"}>
                                                    {t(`${item.label}`)}
                                                </Text>
                                            </MenuButton>
                                        </MenuItem>
                                    </Tooltip>
                                </Link>}
                    </Fragment>
                ))}
            </Menu>
            <UploadDatasetModal isOpen={isUploadOpen} onClose={closeUpload} />
            <Modal onClose={onChangePasswordModalClose} isOpen={isChangePasswordModalOpen} isCentered closeOnOverlayClick={false}>
                <Icon as={MdLockReset} mr={1} /> {t('navbar.changePasswordd')}
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader bgColor={"#0888BE"} color="white" display="flex" justifyContent="space-between"><Box>{t('navbar.changePassword')}</Box> <Box><CloseButton onClick={onChangePasswordModalClose} /></Box></ModalHeader>
                    <ModalBody>
                        <Stack spacing='4'>
                            <Text>
                                <span dangerouslySetInnerHTML={{ __html: t('navbar.changePasswordMsg') }} />
                            </Text>
                            <Box>
                                <FormControl isRequired>
                                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('navbar.newPassword')}</FormLabel>
                                    <InputGroup>
                                        <Input borderColor={"blue.300"} variant='filled' placeholder={t('navbar.newPassword')} name='NuovaPassword1' type={showPassword1 ? "text" : "password"} bg='white' onChange={(e) => handleChangePassword1(e)} />
                                        <InputRightElement width="3rem">
                                            <Button h="1.75rem" size="sm" onClick={handlePasswordVisibility1} bg="transparent">
                                                {showPassword1 ? <Icon as={MdVisibilityOff} boxSize={5} /> : <Icon as={MdVisibility} boxSize={5} />}
                                            </Button>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>
                            </Box>
                            <Box>
                                <FormControl isRequired>
                                    <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t('navbar.enterAgainNewPassword')}:</FormLabel>
                                    <InputGroup>
                                        <Input borderColor={"blue.300"} variant='filled' placeholder={t('navbar.enterAgainNewPassword')} name='NuovaPassword2' type={showPassword2 ? "text" : "password"} bg='white' onChange={(e) => handleChangePassword2(e)} />
                                        <InputRightElement width="3rem">
                                            <Button h="1.75rem" size="sm" onClick={handlePasswordVisibility2} bg="transparent">
                                                {showPassword2 ? <Icon as={MdVisibilityOff} boxSize={5} /> : <Icon as={MdVisibility} boxSize={5} />}
                                            </Button>
                                        </InputRightElement>
                                    </InputGroup>
                                </FormControl>
                            </Box>
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='green' mr={3} onClick={() => changePasswordADP()}>
                            {t('navbar.continue')}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal onClose={onChangeLogoutPasswordModalClose} isOpen={isLogoutChangePasswordModalOpen} isCentered closeOnOverlayClick={false} >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader bgColor={"#0888BE"} color="white" display="flex" justifyContent="space-between"><Box>Logout</Box></ModalHeader>
                    <ModalBody>
                        <Stack spacing='4'>
                            <Text>
                                {responseChangePassword.message ? t(`messageBE.${responseChangePassword.message}`) : ''}
                            </Text>
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='green' mr={3} onClick={() => logOut()}>
                            Logout
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Modal onClose={onLogoutModalClose} isOpen={isLogoutModalOpen} isCentered closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader> {t('navbar.doYouConfirmYouWantToLeaveTheSession')}</ModalHeader>
                    <ModalBody></ModalBody>
                    <ModalFooter>
                        <Button colorScheme='green' mr={3} onClick={logOut}>
                            {t('navbar.yes')}
                        </Button>
                        <Button colorScheme='red' onClick={onLogoutModalClose}>
                            No
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default NavbarDinamic;
